import React, { useEffect, useState } from 'react'
import SampleDataGrid from 'layouts/SampleDataGrid'
import PCRForm from 'forms/PCRForm'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import Protocol from 'protocols/Protocol';
import { sampleNameComparator } from 'utils/utils';
import axios from 'axios';
import moment from 'moment';
import SampleNameAndBadge from 'components/SampleNameAndBadge';

export default function PCR() {
  const [optionsPolymerases, setOptionsPolymerases] = useState()
  useEffect(() => {
    axios.get("/api/wetlab/protocols/pcr/polymerases").then(({data : {data}}) => setOptionsPolymerases(data))
  }, [])
  return (
    <SampleDataGrid
      api={{
        create: "/api/wetlab/protocols/pcr/create",
        read: "/api/wetlab/protocols/pcr/read",
        update: "/api/wetlab/protocols/pcr/update",
        delete: "/api/wetlab/protocols/pcr/discard"}}
      AddForm={PCRForm}
      actions={[
        {
          label: "Step by Step",
          icon: <FormatListNumberedIcon />,
          multiple: true,
          Form: Protocol,
        }
      ]}
      columns={[
        {
          field: 'completed',
          headerName: 'Done',
          width: 40,
          editable: false,
          type: "boolean",
          valueGetter: (_, row) => !!row.time_stop
        },
        {
          field: 'product',
          headerName: 'Product',
          width: 120,
          editable: false,
          valueGetter: (_, row) => row.product?.name,
          sortComparator: sampleNameComparator,
          renderCell: ({row}) => row.product && <SampleNameAndBadge sample={row.product} />,
        },
        {
          field: 'description',
          headerName: 'Description',
          flex: 1,
          editable: false,
          valueGetter: (_, row) => row.product?.description,
        },
        {
          field: 'template',
          headerName: 'Template',
          width: 120,
          editable: false,
          valueGetter: (_, row) => row.template?.name,
          renderCell: ({row}) => row.template && <SampleNameAndBadge sample={row.template} />,
        },
        {
          field: 'primer_fwd',
          headerName: 'Fwd Primer',
          width: 120,
          editable: false,
          valueGetter: (_, row) => row.primer_fwd?.name,
          renderCell: ({row}) => row.primer_fwd && <SampleNameAndBadge sample={row.primer_fwd} />,
        },
        {
          field: 'primer_rev',
          headerName: 'Rev Primer',
          width: 120,
          editable: false,
          valueGetter: (_, row) => row.primer_rev?.name,
          renderCell: ({row}) => row.primer_rev && <SampleNameAndBadge sample={row.primer_rev} />,
        },
        {
          field: 'temp_anneal',
          headerName: "Anneal",
          type: "number",
          width: 80,
          editable: true,
          align: "right",
          renderCell: ({value}) => value && <span>{value} °C</span>,
        },
        {
          field: 'time_extend',
          headerName: "Extend",
          type: "number",
          width: 80,
          editable: true,
          align: "right",
          renderCell: ({value}) => {
            if (!value) return null
            const duration = moment.duration(value, "seconds")
            if (duration.asSeconds() < 60)
              return `${duration.seconds()} sec`
            if (duration.seconds() === 0)
              return `${duration.minutes()} min`
            return `${duration.minutes()}m ${duration.seconds()}s`
          },
        },
        {
          field: 'num_cycles',
          headerName: "Cycles",
          type: "number",
          width: 80,
          align: "right",
          editable: true,
        },
        {
          field: 'reaction_volume',
          headerName: "Volume",
          type: "number",
          width: 85,
          align: "right",
          editable: true,
          renderCell: ({value}) => value && <span>{value} μL</span>,
        },
        {
          field: 'length',
          headerName: "bp",
          type: "number",
          width: 80,
          align: "right",
          editable: false,
          valueGetter: (_, row) => row.product?.length,
        },
        {
          field: 'polymerase',
          headerName: "Polymerase",
          width: 220,
          editable: true,
          type: "singleSelect",
          valueOptions: optionsPolymerases?.map(x => x.name_abbreviated),
          valueGetter: value => optionsPolymerases?.find(x => x.id === value)?.name_abbreviated,
          valueSetter: (value, row) => ({...row, polymerase: optionsPolymerases?.find(x => x.name_abbreviated === value)?.id}),
        },
      ]}
      initialState={{
        sorting: {
          sortModel: [
            { field: "completed", sort: "asc" },
            { field: "product", sort: "asc" },
          ],
        },
        columns: {
          columnVisibilityModel: {
            polymerase: false,
            reaction_volume: false,
          },
        },
      }}
    />
  )
}
